import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root"
})
export class AuthService {

    constructor(
        private _http: HttpClient,
        private _cookieService: CookieService
    ) {}

  getAuthToken() {
    return this._cookieService.get('x-header-authToken');
  }

  setAuthToken(token) {
    this._cookieService.set('x-header-authToken', token);
  }
}
